import React from 'react';
import { Box, Button, Grid, Typography , Link } from '@mui/material';
import { Howl } from 'howler';
import sound1 from './bomb.mp3';
import sound2 from './oh really dude.mp3';
import sound3 from './bloop.mp3';
import sound4 from './dante nero.mp3';
import sound5 from './hava nagila.mp3';
import sound6 from './tony.mp3';
import sound7 from './sober october.mp3';
import sound8 from './jewish.mp3';
import sound9 from './whiny bitch.mp3';
import sound10 from './fools paradise.mp3';
import sound11 from './i said the word.mp3';
import sound12 from './police.mp3';
import sound13 from './prison.mp3';

const Soundboard = () => {
  const sounds = [
    { label: 'bomb', id: 'sound1', file: sound1 },
    { label: 'oh really dude', id: 'sound2', file: sound2 },
    { label: 'bloop', id: 'sound3', file: sound3 },
    { label: 'crack yo jaw', id: 'sound4', file: sound4 },
    { label: 'hava nagila', id: 'sound5', file: sound5 },
    { label: 'tony mf-king hinchcliffe', id: 'sound6', file: sound6 },
    { label: 'sober october', id: 'sound7', file: sound7 },
    { label: 'jewish insult', id: 'sound8', file: sound8 },
    { label: 'whiny little bitch', id: 'sound9', file: sound9 },
    { label: 'fools paradise', id: 'sound10', file: sound10 },
    { label: 'i said the word', id: 'sound11', file: sound11 },
    { label: 'police', id: 'sound12', file: sound12 },
    { label: 'prison', id: 'sound13', file: sound13 },

  ];

  const playSound = (file) => {
    const sound = new Howl({
      src: [file],
    });
    sound.play();
  };

  return (
    <Box sx={{ p: 4, fontFamily: 'Oswald, sans-serif' }}>
      <Typography 
        variant="h4" 
        gutterBottom 
        sx={{ textAlign: 'center', fontFamily: 'Oswald, sans-serif' }}
      >
        REDBAR SOUNDBOARD
      </Typography>
      <Grid container spacing={2} sx={{ rowGap: 4 }}>
        {sounds.map((sound) => (
          <Grid item xs={12} sm={6} md={4} key={sound.id} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              fullWidth
              sx={{ 
                height: '150px', 
                fontWeight: 'bold', 
                color: 'white', 
                backgroundColor: 'black', 
                '&:hover': { backgroundColor: '#333' },
                fontFamily: 'Oswald, sans-serif' 
              }}
              onClick={() => playSound(sound.file)}
            >
              {sound.label}
            </Button>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body1" sx={{ fontFamily: 'Oswald, sans-serif' }}>
          
          <Link href="https://www.youtube.com/playlist?list=PL-JwJjwsNXVM7A6BPMMtaEI8aQojgx6kM" target="_blank" rel="noopener" sx={{ ml: 1, fontWeight: 'bold', textDecoration: 'none' }}>
            check out my redbar clips
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};
export default Soundboard;
